import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import Flag, { CountryCodeType } from './Flag';
import { useRootStoreContext } from '../../stores/RootStore';

const LanguageSelectorWrapper = styled.div`
    display: flex;
    align-items: center;

    > svg {
        cursor: pointer;

        &:not(:last-child) {
            margin-right: 12px;
        }
    }
`;

interface Props extends RouteComponentProps<any> {
    className?: string;
}

const LanguageSelector: FC<Props> = ({ className, history }) => {
    const {
        UIStore: {
            reducer: [uiStoreState],
        },
    } = useRootStoreContext();

    const { i18n } = useTranslation();

    const changeLanguage = (code: CountryCodeType) => {
        i18n.changeLanguage(code);

        // Set lng to query string
        const query = new URLSearchParams(history.location.search);
        query.set('lng', code);
        history.replace({ ...history.location, search: query.toString() });
    };

    let flags = (
        <>
            <Flag code={'is'} onClick={() => changeLanguage('is')} />
            <Flag code={'en'} onClick={() => changeLanguage('en')} />
        </>
    );

    if (uiStoreState.displayCountry === 'es') {
        flags = (
            <>
                <Flag code={'es'} onClick={() => changeLanguage('es')} />
                <Flag code={'en'} onClick={() => changeLanguage('en')} />
            </>
        );
    } else if (uiStoreState.displayCountry === 'nb') {
        flags = (
            <>
                <Flag code={'nb'} onClick={() => changeLanguage('nb')} />
                <Flag code={'en'} onClick={() => changeLanguage('en')} />
            </>
        );
    } else if (uiStoreState.displayCountry === 'dk') {
        flags = (
            <>
                <Flag code={'dk'} onClick={() => changeLanguage('dk')} />
                <Flag code={'en'} onClick={() => changeLanguage('en')} />
            </>
        );
    }

    return (
        <LanguageSelectorWrapper className={className}>
            {flags}
        </LanguageSelectorWrapper>
    );
};

export default withRouter(LanguageSelector);
